import palette from '@sdk/theme/colorsLight';

export const DEFAULT_SETTINGS = {
  backgroundColor: palette.bodyBg,
  foregroundColor: palette.bodyBgLight,
  speed: 2,
};
